<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <h1 class="brand-text text-primary ml-1">{{ $brand.brandNameEn }}</h1>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
            Welcome to {{ $brand.brandNameEn }}! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Please sign-in to your account and start using
            {{ $brand.brandNameEn }}
          </b-card-text>

          <b-alert variant="primary" show> </b-alert>

          <!-- form -->
          <validation-observer ref="loginForm" #default="{ invalid }">
            <b-form class="auth-login-form mt-2" @submit.prevent="login">
              <!-- email -->
              <b-form-group label="User Name" label-for="username">
                <validation-provider
                  #default="{ errors }"
                  name="User Name"
                  vid="username"
                  rules="required"
                >
                  <b-form-input
                    id="username"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="username"
                    placeholder="alex.john"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group label="Password" label-for="password">
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                Sign in
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";
import $http from "@/plugins/axios.js";
import router from "@/router/index.js";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: "",
      userData: [],
      userPermissions: [],
      token: "",
      password: "",
      userEmail: "",
      errorValidate: {
        email: true,
        password: true,
      },
      sideImg: require("@/assets/images/pages/login-v2.svg"),

      // validation rules
      required,
      email,

      departments: [
        "Reception", //1
        "IT Managment", //2
        "Clinic", //3
        "Emergency", //4
        "Laboratory", //5
        "Pharmacy", //6
        "DailyCare", //7
        "Consultant", //8
        "Chemotherapy", //11
      ],
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/login-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    async updated() {
      if (localStorage.getItem("accessToken")) {
        try {
          await this.getList(`/auth/user-profile`);
          this.$store.state.app.permissions = this.all_data.permissions;
          localStorage.setItem(
            "permissions",
            JSON.stringify(this.all_data.permissions)
          );
          this.$store.state.app.roles = this.all_data.roles[0].name;
        } catch (error) {
          alert(error)
        }
      }
    },
    login() {
      this.$refs.loginForm.validate().then((success) => {
        if (success) {
          useJwt
            .login({
              email: this.userEmail,
              password: this.password,
            })
            .then(async (response) => {
              this.userData = response.data.userAuth;
              this.token = response.data.token;

              useJwt.setToken(this.token);
              localStorage.setItem("userData", JSON.stringify(this.userData));
              // localStorage.setItem("userRole", JSON.stringify(this.userData));

              // Get user role from store after setting permissions/roles
              await this.updated(); // This updates the store with user roles

              // Get the user's role and redirect accordingly
              const userRole = this.$store.state.app.roles;
              // console.log("userRole-login", userRole);
              const redirectPath = getHomeRouteForLoggedInUser(userRole);
              localStorage.setItem("userRole", JSON.stringify(userRole));

              this.$router.replace(redirectPath).then(() => {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: `Welcome ${
                      this.userData.name || this.userData.username
                    }`,
                    icon: "CoffeeIcon",
                    variant: "success",
                    text: `You have successfully logged in as ${this.userData.name}. Now you can start to explore!`,
                  },
                });
              });
            })
            .catch((error) => {
              // this.$refs.loginForm.setErrors(error.response.data)
              if (error.code == "ERR_NETWORK") {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Login Failed",
                    icon: "CoffeeIcon",
                    variant: "danger",
                    text:
                      error.message + ", There may be an issue with the server",
                  },
                });
              } else if (error.response.status === 401) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Login Failed",
                    icon: "CoffeeIcon",
                    variant: "danger",
                    text: error.response.data.message,
                  },
                });
              } else if (error.response.status === 400) {
                var errorObj = error.response.data;
                for (var key in errorObj) {
                  var value = errorObj[key];
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Login Failed",
                      icon: "CoffeeIcon",
                      variant: "danger",
                      text: `${value[0]}`,
                    },
                  });
                }
              } else {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Login Failed",
                    icon: "CoffeeIcon",
                    variant: "danger",
                    text: error.response.data.message,
                  },
                });
              }
            });
        }
      });
    },
    async checkAuth() {
      this.userPermissions = await $http.get("/auth/details");
      localStorage.setItem(
        "permissions",
        JSON.stringify(this.userPermissions.data.all_permissions)
      );
      // console.log('details', response.data);
      // this.userPermissions = response.data.all_permissions
      //   .catch(() => {
      //     localStorage.removeItem('userData')
      //     localStorage.removeItem('accessToken')
      //     router.push('/login')
      //   })
      // commit('SET_PERMISSIONS', response.data)
      // commit('SET_ROLES', response.data)
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
